import { theme } from '@ublend-npm/aulaui-next';

export const blockStyle = ({ isSelected }: { isSelected: boolean }) => `
  display: flex;
  position: relative;
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  text-decoration: none;
  color: ${theme.color.black};
  background-color: ${
    isSelected
      ? theme.color.designSystem.purple30
      : theme.color.designSystem.grey20
  };
  border-radius: ${theme.borderRadius.medium};
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.small};

  // Account for the border when adding padding
  padding: calc(${theme.spacing.small} - 1px);
  border: ${
    isSelected
      ? `1px solid ${theme.color.designSystem.blackOpacity87}`
      : `1px solid ${theme.color.designSystem.grey20}`
  };

  &:focus {
    border: 1px solid ${theme.color.designSystem.blackOpacity87};
  }

  ${
    !isSelected
      ? `&:hover {
        background-color: #D6D6D6;
    }`
      : ``
  }
`;
